// src/App.js
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import { FEATURE_BITS as FB } from "./constants/permisos";

// Públicas
import Inicio from "./components/Inicio";
import Verificar2FA from "./components/Verificar2FA";
import RecuperarContrasena from "./components/RecuperarContrasena";

// Protección
import PrivateRoute from "./components/PrivateRoute";

// Dashboard (contenedor único de vistas internas)
import DashboardAdmin from "./components/Dashboard/DashboardAdmin";

import MisEstadisticas from "./components/Inicio/MisEstadisticas";
import MisSensores from "./components/Inicio/MisSensores";
import BubbleBackground from "./components/BubbleBackground";


/* ===========================
   Helper: redirige al dashboard
   mapeando a ?tab=&sub=
=========================== */
const RedirectToDashboard = ({ tab, sub }) => {
  const search = new URLSearchParams();
  if (tab) search.set("tab", tab);
  if (sub) search.set("sub", sub);

  const qs = search.toString();
  const to = qs ? `/dashboard/admin?${qs}` : "/dashboard/admin";

  return <Navigate to={to} replace />;
};

function App() {
  return (
    <>
      <BubbleBackground />
      <ToastContainer
        position="top-right"
        autoClose={4500}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
        toastClassName="app-toast"
      />
      <div className="app-content">
      <Routes>
        {/* ===================== RUTAS PÚBLICAS ===================== */}
        <Route path="/" element={<Inicio />} />
        <Route path="/verificar-2fa" element={<Verificar2FA />} />
        <Route path="/recuperar" element={<RecuperarContrasena />} />

        {/* ===================== PRIVADAS ===================== */}

        {/* ---------- Dashboard único ---------- */}
        <Route
          path="/dashboard/admin"
          element={
            <PrivateRoute requireBits={[FB.INICIO_VIEW]}>
              <DashboardAdmin />
            </PrivateRoute>
          }
        />

        {/* ---------- NUEVA RUTA: Inicio → Mis Sensores ---------- */}
        <Route
          path="/inicio/mis-sensores"
          element={
            <PrivateRoute requireBits={[FB.INICIO_VIEW]}>
              <MisSensores />
            </PrivateRoute>
          }
        />

        {/* ===================== REDIRECCIONES A DASHBOARD (sin acceso directo) ===================== */}
        {/* Estanques */}
        <Route
          path="/estanques"
          element={
            <PrivateRoute requireBits={[FB.ESTANQUES_VIEW]}>
              <RedirectToDashboard tab="Estanques" sub="tablero" />
            </PrivateRoute>
          }
        />
        <Route
          path="/estanques/crear"
          element={
            <PrivateRoute requireBits={[FB.ESTANQUES_TAB_CREAR_VIEW, FB.ESTANQUES_TAB_CREAR_EDIT]}>
              <RedirectToDashboard tab="Estanques" sub="crear" />
            </PrivateRoute>
          }
        />
        <Route
          path="/estanques/administrar"
          element={
            <PrivateRoute requireBits={[FB.ESTANQUES_TAB_EDITAR_VIEW]}>
              <RedirectToDashboard tab="Estanques" sub="administrar" />
            </PrivateRoute>
          }
        />

        {/* Dispositivos */}
        <Route
          path="/dispositivos"
          element={
            <PrivateRoute requireBits={[FB.DISPOSITIVOS_VIEW]}>
              <RedirectToDashboard tab="Dispositivos" sub="tablero" />
            </PrivateRoute>
          }
        />
        <Route
          path="/dispositivos/nuevo"
          element={
            <PrivateRoute requireBits={[FB.DISPOSITIVOS_TAB_CREAR_VIEW, FB.DISPOSITIVOS_TAB_CREAR_EDIT]}>
              <RedirectToDashboard tab="Dispositivos" sub="crear" />
            </PrivateRoute>
          }
        />
        <Route
          path="/inicio/mis-estadisticas"
          element={
            <PrivateRoute requireBits={[FB.INICIO_VIEW]}>
              <MisEstadisticas />
            </PrivateRoute>
          }
        />

        {/* Sensores */}
        <Route
          path="/sensores"
          element={
            <PrivateRoute requireBits={[FB.SENSORES_VIEW]}>
              <RedirectToDashboard tab="Sensores" sub="tablero" />
            </PrivateRoute>
          }
        />
        <Route
          path="/sensores/crear"
          element={
            <PrivateRoute requireBits={[FB.SENSORES_TAB_CREAR_VIEW, FB.SENSORES_TAB_CREAR_EDIT]}>
              <RedirectToDashboard tab="Sensores" sub="crear" />
            </PrivateRoute>
          }
        />
        <Route
          path="/sensores/administrar"
          element={
            <PrivateRoute requireBits={[FB.SENSORES_TAB_EDITAR_VIEW]}>
              <RedirectToDashboard tab="Sensores" sub="administrar" />
            </PrivateRoute>
          }
        />

        {/* Efectores */}
        <Route
          path="/efectores"
          element={
            <PrivateRoute requireBits={[FB.EFECTORES_VIEW]}>
              <RedirectToDashboard tab="Efectores" sub="tablero" />
            </PrivateRoute>
          }
        />
        <Route
          path="/efectores/administrar"
          element={
            <PrivateRoute requireBits={[FB.EFECTORES_TAB_EDITAR_VIEW]}>
              <RedirectToDashboard tab="Efectores" sub="administrar" />
            </PrivateRoute>
          }
        />

        {/* Automatización */}
        <Route
          path="/automatizacion"
          element={
            <PrivateRoute requireBits={[FB.AUTOMATIZACION_VIEW]}>
              <RedirectToDashboard tab="Automatización" sub="tablero" />
            </PrivateRoute>
          }
        />
        <Route
          path="/automatizacion/sensores"
          element={
            <PrivateRoute requireBits={[FB.AUTOMATIZACION_TAB_SENSORES_VIEW]}>
              <RedirectToDashboard tab="Automatización" sub="sensores" />
            </PrivateRoute>
          }
        />
        <Route
          path="/automatizacion/efectores"
          element={
            <PrivateRoute requireBits={[FB.AUTOMATIZACION_TAB_EFECTORES_VIEW]}>
              <RedirectToDashboard tab="Automatización" sub="efectores" />
            </PrivateRoute>
          }
        />

        {/* Alarmas */}
        <Route path="/alarmas" element={<PrivateRoute requireBits={[FB.ALARMAS_VIEW]}><RedirectToDashboard tab="Alarmas" sub="tablero" /></PrivateRoute>} />
        <Route path="/alarmas/programar" element={<PrivateRoute requireBits={[FB.ALARMAS_TAB_CREAR_VIEW]}><RedirectToDashboard tab="Alarmas" sub="programar" /></PrivateRoute>} />
        <Route path="/alarmas/administrar" element={<PrivateRoute requireBits={[FB.ALARMAS_TAB_ADMIN_VIEW]}><RedirectToDashboard tab="Alarmas" sub="administrar" /></PrivateRoute>} />
        <Route path="/alarmas/historial" element={<PrivateRoute requireBits={[FB.ALARMAS_TAB_HISTORIAL_VIEW]}><RedirectToDashboard tab="Alarmas" sub="historial" /></PrivateRoute>} />

        {/* Usuarios (permanentes) */}
        <Route
          path="/usuarios"
          element={
            <PrivateRoute requireBits={[FB.CONFIGURACIONES_VIEW]}>
              <RedirectToDashboard tab="Configuraciones" sub="perfil" />
            </PrivateRoute>
          }
        />

        {/* Usuarios temporales */}
        <Route
          path="/usuarios-temporales"
          element={
            <PrivateRoute requireBits={[FB.USUARIOS_TEMP_VIEW]}>
              <RedirectToDashboard tab="Usuarios Temporales" sub="administrar" />
            </PrivateRoute>
          }
        />
        <Route
          path="/usuarios-temporales/crear"
          element={
            <PrivateRoute requireBits={[FB.USUARIOS_TEMP_TAB_CREAR_VIEW, FB.USUARIOS_TEMP_TAB_CREAR_EDIT]}>
              <RedirectToDashboard tab="Usuarios Temporales" sub="crear" />
            </PrivateRoute>
          }
        />
        <Route
          path="/usuarios-temporales/administrar"
          element={
            <PrivateRoute requireBits={[FB.USUARIOS_TEMP_TAB_EDITAR_VIEW]}>
              <RedirectToDashboard tab="Usuarios Temporales" sub="administrar" />
            </PrivateRoute>
          }
        />
        <Route
          path="/usuarios-temporales/asignar"
          element={
            <PrivateRoute requireBits={[FB.USUARIOS_TEMP_EDIT]}>
              <RedirectToDashboard tab="Usuarios Temporales" sub="asignar" />
            </PrivateRoute>
          }
        />

        {/* Reportería */}
        <Route
          path="/reporteria"
          element={
            <PrivateRoute requireBits={[FB.REPORTERIA_VIEW]}>
              <RedirectToDashboard tab="Reportería" />
            </PrivateRoute>
          }
        />

        {/* Configuraciones (home) */}
        <Route
          path="/configuraciones"
          element={
            <PrivateRoute requireBits={[FB.CONFIGURACIONES_VIEW]}>
              <RedirectToDashboard tab="Configuraciones" sub="perfil" />
            </PrivateRoute>
          }
        />

        {/* Configuraciones → Parámetros */}
        <Route
          path="/configuraciones/parametros"
          element={
            <PrivateRoute requireBits={[FB.CONFIGURACIONES_VIEW, FB.CONFIGURACIONES_EDIT]}>
              <RedirectToDashboard tab="Configuraciones" sub="parametros" />
            </PrivateRoute>
          }
        />
        <Route
          path="/config/parametros"
          element={
            <PrivateRoute requireBits={[FB.CONFIGURACIONES_VIEW, FB.CONFIGURACIONES_EDIT]}>
              <RedirectToDashboard tab="Configuraciones" sub="parametros" />
            </PrivateRoute>
          }
        />
        <Route
          path="/configuraciones/valores-referencia"
          element={
            <PrivateRoute requireBits={[FB.CONFIGURACIONES_VIEW, FB.CONFIGURACIONES_EDIT]}>
              <RedirectToDashboard tab="Configuraciones" sub="parametros" />
            </PrivateRoute>
          }
        />

        {/* Configuraciones → Firmware */}
        <Route
          path="/configuraciones/firmware"
          element={
            <PrivateRoute requireBits={[FB.CONFIGURACIONES_VIEW, FB.CONFIGURACIONES_TAB_FIRMWARE_VIEW]}>
              <RedirectToDashboard tab="Configuraciones" sub="firmware" />
            </PrivateRoute>
          }
        />
        <Route
          path="/configuraciones/firmware/flashear"
          element={
            <PrivateRoute requireBits={[FB.CONFIGURACIONES_VIEW, FB.FIRMWARE_TAB_FLASH_VIEW]}>
              <RedirectToDashboard tab="Configuraciones" sub="firmware-flashear" />
            </PrivateRoute>
          }
        />
        <Route
          path="/configuraciones/firmware/configurar"
          element={
            <PrivateRoute requireBits={[FB.CONFIGURACIONES_VIEW, FB.FIRMWARE_TAB_CONFIG_VIEW]}>
              <RedirectToDashboard tab="Configuraciones" sub="firmware-configurar" />
            </PrivateRoute>
          }
        />
        <Route
          path="/configuraciones/firmware/ota"
          element={
            <PrivateRoute superAdminOnly requireBits={[FB.CONFIGURACIONES_VIEW, FB.FIRMWARE_TAB_OTA_VIEW]}>
              <RedirectToDashboard tab="Configuraciones" sub="firmware-ota" />
            </PrivateRoute>
          }
        />

        {/* Catch-all → Inicio público */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </div>
    </>
  );
}

export default App;
